import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Tooltip,
  useTheme,
  Drawer,
  IconButton,
} from "@mui/material";
import {
  ExpandLessRounded,
  ExpandMoreRounded,
  Check,
  ChevronRightRounded,
  CloseRounded,
} from "@mui/icons-material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  icon: {
    margin: "0px 5px 0px -6px !important",
    color: theme.palette.action.active,
  },
  missingOppositeContent: {
    "&:before": {
      display: "none",
    },
  },
}));

function AnalysisLogs({ answer }) {
  const theme = useTheme();
  const { classes } = useStyles();
  const [areLogsOpen, setAreLogsOpen] = useState(false);

  const steps =
    answer["content_object"]["tabular_data_result"] &&
    answer["content_object"]["tabular_data_result"]["process_steps_log"]
      ? answer["content_object"]["tabular_data_result"]["process_steps_log"][
          "steps"
        ]
      : [];

  const toggleLogs = () => {
    setAreLogsOpen((prev) => !prev);
  };

  return (
    <>
      <Box display={"flex"} alignItems={"center"}>
        <Chip
          // variant={areLogsOpen ? "filled" : "outlined"}
          classes={{ icon: classes.icon }}
          label={"Analysis"}
          icon={<ChevronRightRounded sx={{ fontSize: 16 }} />}
          onClick={toggleLogs}
          sx={{
            background: "transparent",
            flexDirection: "row-reverse",
            color: theme.palette.text.secondary,
          }}
        />
      </Box>
      {areLogsOpen && (
        <Logs steps={steps} onClose={() => setAreLogsOpen(false)} />
      )}
    </>
  );
}

function Logs({ steps, onClose }) {
  const { classes } = useStyles();

  const processedSteps = steps.map((step) => {
    const [title, value] = step.split(":", 2);
    return { title: title.trim(), value: value.trim() };
  });

  return (
    <Drawer
      open={true}
      onClose={onClose}
      anchor="right"
      PaperProps={{
        sx: {
          width: 420,
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
          padding: 2,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        },
      }}>
      <Box display={"flex"} justifyContent={"space-between"} pb={2}>
        <Typography variant="h6">Analysis Logs</Typography>
        <IconButton onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </Box>
      <Box flexGrow={1} overflow={"auto"} pt={2}>
        <Timeline sx={{ padding: 0, margin: 0 }}>
          {processedSteps.map((step, i) => {
            const { title, value } = step;
            return (
              <TimelineItem
                key={i}
                classes={{
                  missingOppositeContent: classes.missingOppositeContent,
                }}
                sx={{ minHeight: i === processedSteps.length - 1 ? 0 : 70 }}>
                <TimelineSeparator>
                  <Tooltip title={title}>
                    <TimelineDot sx={{ padding: 0, marginTop: "9px" }}>
                      <Check sx={{ fontSize: 10 }} />
                    </TimelineDot>
                  </Tooltip>
                  {i !== processedSteps.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent sx={{ width: "100%" }}>
                  <Typography variant="subtitle2" color={"textSecondary"}>
                    {value}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </Box>
    </Drawer>
  );
}

export default AnalysisLogs;
